export default __webpack_public_path__ + "static/media/tag.9e0052e8.svg";